import React from "react";

const HideEye = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M6.938 8.66L2.314 4.075 4.406 2l29.28 29.037-2.092 2.074-4.895-4.854A16.293 16.293 0 0118 30.754c-7.974 0-14.608-5.69-16-13.198A16.069 16.069 0 016.94 8.66h-.002zm15.14 15.014l-2.166-2.147a4.47 4.47 0 01-5.052-.858 4.367 4.367 0 01-.865-5.01l-2.165-2.147a7.285 7.285 0 00.938 9.232 7.443 7.443 0 009.31.93zM12.045 5.47A16.372 16.372 0 0118 4.357c7.974 0 14.608 5.69 16 13.199a15.988 15.988 0 01-2.976 6.734l-5.708-5.66c.17-1.134.07-2.29-.293-3.377a7.323 7.323 0 00-1.793-2.886 7.406 7.406 0 00-2.91-1.777 7.455 7.455 0 00-3.404-.29l-4.87-4.827V5.47z"
            fill={fill}
        />
    </svg>
);

export default HideEye;
